import { useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { css } from "../../../../styled-system/css";
import { MenuButton, Menu, MenuItem } from "../../../components/core/basic/Menu";
import { SearchInput } from "../../../components/fields/base/TextField";

export function FilterColumnSelector({
  filterOptions,
  onSelect,
}: {
  filterOptions: { id: string; label: string }[];
  onSelect: (id: string) => void;
}) {
  const [search, setSearch] = useState("");
  return (
    <MenuButton
      buttonProps={{
        variant: "contentOnly",
      }}
      label={
        <>
          <FaPlus /> Add Filter
        </>
      }
    >
      <SearchInput
        aria-label={"Filter by"}
        placeholder={"Filter By..."}
        className={css({
          margin: "small",
        })}
        value={search}
        onChange={setSearch}
      />
      <Menu onClose={() => setSearch("")} className={css({ maxHeight: "33vh", overflowY: "auto" })}>
        {filterOptions
          .filter((filterable) => filterable.label.toLowerCase().includes(search.toLowerCase()))
          .map((filterable) => (
            <MenuItem key={filterable.id} onAction={() => onSelect(filterable.id)}>
              {filterable.label}
            </MenuItem>
          ))}
      </Menu>
    </MenuButton>
  );
}
